import { createProvider } from '@nvision/services/data-provider';

import type { ClassFilters } from '../../models';
import * as api from './api';
import { normalizeClasses, normalizeClassFilters } from './normalize';

export const fetchClasses = createProvider(
  (filters: Partial<ClassFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchClasses(normalizeClassFilters(filters), { signal }),
).andThen((res) => normalizeClasses(res));
